var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "design-layout-sortable",
    style: {
      right: _vm.isExpand ? "0" : "-278px"
    }
  }, [_c("div", {
    staticClass: "expand",
    class: _vm.isExpand == false ? "arrow-right" : "",
    on: {
      click: _vm.handleExpand
    }
  }, [_c("svg", {
    staticClass: "svg-icon icon panel-icon",
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 86",
      "aria-hidden": "true",
      width: "16",
      height: "86"
    }
  }, [_c("g", {
    attrs: {
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("path", {
    staticClass: "path-wapper",
    attrs: {
      d: "M0 0l14.12 8.825A4 4 0 0116 12.217v61.566a4 4 0 01-1.88 3.392L0 86V0z",
      fill: "#409EFF"
    }
  }), _c("path", {
    staticClass: "path-arrow",
    attrs: {
      d: "M10.758 48.766a.778.778 0 000-1.127L6.996 43l3.762-4.639a.778.778 0 000-1.127.85.85 0 00-1.172 0l-4.344 5.202a.78.78 0 000 1.128l4.344 5.202a.85.85 0 001.172 0z",
      fill: "#fff",
      "fill-rule": "nonzero"
    }
  })])])]), _c("div", {
    staticClass: "design-layout-sortable-wrapper"
  }, [_c("h2", {
    staticClass: "sortable-head"
  }, [_vm._v("内容设置")]), _vm.pageData ? _c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("CardItem", {
    attrs: {
      leyout: "vertical"
    }
  }, [_c("a-select", {
    on: {
      change: _vm.handleTypeChange
    },
    model: {
      value: _vm.pageData.checkType,
      callback: function callback($$v) {
        _vm.$set(_vm.pageData, "checkType", $$v);
      },
      expression: "pageData.checkType"
    }
  }, _vm._l(_vm.showTypes, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1)], 1) : _vm._e()], 1), _c("FormPage", {
    attrs: {
      component: _vm.component
    }
  }), _c("SimpleFormPage", {
    attrs: {
      component: _vm.simpleComponent
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };